/*Subject是微信公众号，Observable是微信用户。(类比)*/
/*1个Subject可以对应n个不同的Observable，Observable只要向Subject要求接收，每次Subject的更新都能即时收到。*/
/*就如1个微信公众号可以有n个没用必然关系的微信用户，只要微信用户关注了微信公众号，每次微信公众号的更新都能及时收到。*/

/**********这里专门处理 给别的地方调用 ng2的接口（即订阅对象）*************/
import { Injectable } from '@angular/core';
// import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import 'rxjs/Rx';

// import { Http, Headers, Request, Response, RequestOptions, RequestMethod } from '@angular/http';
// import { RequestArgs } from '@angular/http/src/interfaces';
import {ModMenuService, tabMenu} from "../home-page/mod-menu.service";


@Injectable()
export class InterfaceSubjectService {

  public jsCreateTabSub: Subject<any> = new Subject<any>();//给js调用的订阅对象 打开选项卡

  constructor(private menuService: ModMenuService) {
    console.log("Angular2---------InterfaceSubjectService.constructor");
  }


  /**用来打开 某些 定义在菜单或者模块里面的特定组件
   * 如：js点击一个按钮 要打开 ng2对应的邮件组件 或者 流程列表组件 或者一些特定的选项卡的
   *@param  tabId  选项卡 对应的id （重复打开的时候 需要用这个直接校验到对应的选项卡）
   * @param  tabName 选项卡名字
   * @param addr 选项卡引用的地址
   * */
  createLinkTab(tabId,tabName,addr){
    if(!tabId ||!tabName ||!addr) return;
    let tabmenu = new tabMenu(tabName, tabId.toString(), "cpclink");
    tabmenu.tabUrl = addr;
    tabmenu.allowClose = true;
    if (tabmenu.tabUrl.endsWith("Component") || tabmenu.tabUrl.indexOf("module") !== -1) {
      tabmenu.componentName = tabmenu.tabUrl;
    }
    else {
      tabmenu.componentName = "FrameConComponent";
    }

    this.menuService.addTabMenu(tabmenu);
  }

  /**用来打开 特定的组件或者 地址
   * 如：js点击一个按钮 要打开 ng2对应的邮件组件 或者 流程列表组件 或者一些特定的选项卡的
   * @param addr 选项卡引用的地址
   * */
  createComponentTab(addr){
    if(!addr) return;
    //打开邮件要特殊处理。
    if(addr == "EmailComponent"){
      this.menuService.createEmailTab();
    }
    if(addr == "WfComponent"){
      this.menuService.createWfListTab();
    }
    else{
      //打开别的组件
      let hasTopBar= false;
      let index ;
      for(let i=0;i<this.menuService.TopBar.length;i++){
        if(this.menuService.TopBar[i].componentName == addr){
          hasTopBar=true;
          index = i;
          break;
        }
      }
      // if(this.menuService.modMenus)
      let mod,menu;
      if(hasTopBar){
        let tabmenu:tabMenu ;
        tabmenu = this.menuService.TopBar[index];
        this.menuService.addTabMenu( tabmenu);
      }
      else{
        let mods = JSON.parse(window.sessionStorage.getItem('mods')).mods;
        let menus = JSON.parse(window.sessionStorage.getItem('mods')).menus;
        let isFind = false;
        //先循环一遍 mod 流程组件是否定义在 模块里面
        for (let i = 0; i < mods.length; i++) {
          if (mods[i].refaddr == addr) {
            isFind = true;
            mod = mods[i];
            break;
          }
          if (!isFind) {
            if( mods[i].modofmods){
              for (let j = 0; j < mods[i].modofmods.length; j++) {
                if (mods[i].modofmods[j].refaddr == addr) {
                  isFind = true;
                  mod = mods[i].modofmods[j];
                  break;
                }
              }
            }


          }
        }
        if(!isFind){
          for (let i = 0; i < menus.length; i++) {
            if (menus[i].refaddr == addr) {
              isFind = true;
              menu = menus[i];
              break;
            }
            if (!isFind) {
              if(menus[i].menuofmenus){
                for (let j = 0; j < menus[i].menuofmenus.length; j++) {
                  if (menus[i].menuofmenus[j].refaddr == addr) {
                    isFind = true;
                    menu = menus[i].menuofmenus[j];
                    break;
                  }
                }
              }

            }
          }
        }

        if(mod){
          let tabmenu = new tabMenu(mod.modname, mod.modid.toString(), "cpcmod");
          //引用地址 用户有可能 前后有空格 需要删除
          tabmenu.tabUrl = mod.refaddr.trim();
          tabmenu.menus = mod.menuofmods;
          tabmenu.autoreload = mod.autoreload;
          if (tabmenu.tabUrl.endsWith("Component") || tabmenu.tabUrl.indexOf("module") !== -1) {
            tabmenu.componentName = tabmenu.tabUrl;
          }
          else {
            tabmenu.componentName = "FrameConComponent";
          }
          this.menuService.addTabMenu(tabmenu);

        }
        else if(menu){
          let tabmenu = new tabMenu(menu.menuname, menu.menuid.toString(), "cpcmenu");
          tabmenu.tabUrl = menu.refaddr;
          if (tabmenu.tabUrl.endsWith("Component") || tabmenu.tabUrl.indexOf("module") !== -1) {
            tabmenu.componentName = tabmenu.tabUrl;
          }
          else {
            tabmenu.componentName = "FrameConComponent";
          }
          tabmenu.allowClose = true;
          this.menuService.addTabMenu(tabmenu);
        }
        else{
          alert('没有找到对应的模块或者菜单，所以不能打开选项卡！请联系管理员！');
          return
        }
      }
    }



  }

}



// WEBPACK FOOTER //
// D:/cpc/sinocc.web/web.X6/www/x6.ng2/src/app/cpc-services/interface.subject.service.ts